import type { BookingDetailsAccommodation, BookingDetailsRoomDescription } from '../../domain/types'
import type { BookingDetailsAccommodationAPIResponse } from '../types'

function groupRoomDescriptions(rooms: string[]): BookingDetailsRoomDescription[] {
  const countMap = new Map<string, number>()

  for (const room of rooms) {
    const normalized = room.replace(/\s*,\s*/g, ', ').replace(/\s+/g, ' ').trim()
    if (!normalized)
      continue
    countMap.set(normalized, (countMap.get(normalized) ?? 0) + 1)
  }

  return Array.from(countMap.entries()).map(([description, count]) => ({ description, quantity: count }))
}

export function accommodationsMapper(
  accommodations: BookingDetailsAccommodationAPIResponse[] | undefined,
): BookingDetailsAccommodation[] {
  if (!accommodations) {
    return []
  }

  return accommodations.map(acc => ({
    name: acc.name || '',
    imageUrl: acc.imageURL || '',
    url: acc.url || '',
    checkInDate: acc.checkInDate || '',
    checkOutDate: acc.checkOutDate || '',
    roomsDescription: acc.roomsDescription ? groupRoomDescriptions(acc.roomsDescription) : undefined,
    address: {
      country: acc.address?.country || '',
      region: acc.address?.region || '',
      city: acc.address?.city || '',
      streetName: acc.address?.streetName || '',
      postalCode: acc.address?.postalCode || '',
    },
  }))
}
